<template>
  <div class="item">
    <v-layout>
      <v-flex sm12>
        <item v-for="n in itemCount" :key="`item-${n}`"/>
        <v-btn color="primary" large block @click="itemCount += 1">Add Another Item</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Item from './item.vue'

  export default {
    components: {
      item: Item
    },

    data () {
      return {
        itemCount: 1
      }
    },

    metaInfo () {
      return {
        title: `Proxy Create`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?6cd709bd